import {PIXI} from '@colonist/pixi'
import {UIGameAnimationBase} from './animation/UIGameAnimationBase'

export class UIGameVerticalMovementAnimation extends UIGameAnimationBase {
    private readonly initialY: number
    private animationDirection: number = -1
    private readonly maxAnimationDistance: number
    private readonly animationSpeedMultiplier: number
    protected readonly forceEnableAnimation: boolean = false

    constructor(viewToAnimate: PIXI.Container, maxAnimationDistance: number, animationSpeedMultiplier: number = 1) {
        super()
        this.initialY = viewToAnimate.y
        this.maxAnimationDistance = maxAnimationDistance
        this.animationSpeedMultiplier = animationSpeedMultiplier
        this.viewToAnimate = viewToAnimate
        this.setOnStopCallback(() => this.resetToDefaultState())
    }

    onGameTick(deltaTime: number, elapsedMS: number) {
        if(this.viewToAnimate == undefined) this.stop()
        this.viewToAnimate.y += this.viewToAnimate.height * 0.003 * this.animationDirection * this.animationSpeedMultiplier * deltaTime

        const isTopEdge = this.viewToAnimate.y < this.initialY - this.maxAnimationDistance
        const isBottomEdge = this.viewToAnimate.y > this.initialY
        if(isTopEdge) {
            this.animationDirection = 1
            this.viewToAnimate.y = this.initialY - this.maxAnimationDistance
        }
        if(isBottomEdge) {
            this.animationDirection = -1
            this.viewToAnimate.y = this.initialY
        }
    }

    resetToDefaultState(): void {
        this.viewToAnimate.y = this.initialY
    }
}
